import React from "react";
import { Col, Row, Container, Navbar, Button } from "react-bootstrap";
import { loginRequest } from "../authConfig";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal
} from "@azure/msal-react";

const Navigator: React.FunctionComponent<any> = (props) => {
  const { instance } = useMsal();

  const handleLoginRedirect = () => {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };

  const handleLogoutRedirect = () => {
    instance.logoutRedirect().catch((error) => console.log(error));
  };

  return (
    <>
      <Navbar
        bg="primary"
        variant="dark"
        className="navbarStyle"
        style={{ padding: "10px" }}>
        <a className="navbar-brand" href="/">
          Hofstaete SLA Reporter
        </a>
        <AuthenticatedTemplate>
          <div className="collapse navbar-collapse justify-content-end">
            <Button variant="warning" onClick={handleLogoutRedirect}>
              Sign out
            </Button>
          </div>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <div className="collapse navbar-collapse justify-content-end">
            <Button onClick={handleLoginRedirect}>Sign in</Button>
          </div>
        </UnauthenticatedTemplate>
      </Navbar>
    </>
  );
};

export const Layout: React.FunctionComponent<any> = (props) => {
  return (
    <>
      <Navigator />
      <AuthenticatedTemplate>
        <Container fluid>
          <Row>
            <Col style={{ padding: "10px" }}>{props.children}</Col>
          </Row>
        </Container>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <h2>Sign in first.</h2>
      </UnauthenticatedTemplate>
    </>
  );
};
